var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2085 4.69698C11.673 3.23252 14.0474 3.23252 15.5118 4.69698C16.9763 6.16145 16.9763 8.53582 15.5118 10.0003L14.628 10.8842C14.3839 11.1282 13.9881 11.1282 13.7441 10.8842C13.5 10.6401 13.5 10.2444 13.7441 10.0003L14.628 9.1164C15.6043 8.14009 15.6043 6.55718 14.628 5.58087C13.6516 4.60456 12.0687 4.60456 11.0924 5.58087L10.2085 6.46475C9.96446 6.70883 9.56873 6.70883 9.32465 6.46475C9.08057 6.22067 9.08057 5.82494 9.32465 5.58087L10.2085 4.69698ZM12.838 7.37083C13.0821 7.61491 13.0821 8.01063 12.838 8.25471L8.46298 12.6297C8.2189 12.8738 7.82317 12.8738 7.57909 12.6297C7.33502 12.3856 7.33502 11.9899 7.57909 11.7458L11.9541 7.37083C12.1982 7.12675 12.5939 7.12675 12.838 7.37083ZM6.673 9.1164C6.91708 9.36048 6.91708 9.75621 6.673 10.0003L5.78912 10.8842C4.81281 11.8605 4.81281 13.4434 5.78912 14.4197C6.76543 15.396 8.34834 15.396 9.32465 14.4197L10.2085 13.5358C10.4526 13.2917 10.8483 13.2917 11.0924 13.5358C11.3365 13.7799 11.3365 14.1756 11.0924 14.4197L10.2085 15.3036C8.74407 16.7681 6.3697 16.7681 4.90523 15.3036C3.44077 13.8391 3.44077 11.4647 4.90523 10.0003L5.78912 9.1164C6.0332 8.87232 6.42892 8.87232 6.673 9.1164Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLink);
export default __webpack_public_path__ + "static/media/youtube_link.747b313e31354eaa2275ca2e8862c91f.svg";
export { ForwardRef as ReactComponent };